module.exports = __webpack_public_path__ + "img/ring_g_e_0_0@3x.41e57b83.png";